import _extends from "@babel/runtime/helpers/esm/extends";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";

var _class, _class2, _temp;

import React from 'react';
import PropTypes from 'prop-types';
import { isElement } from 'react-is';
import { globalObject } from '@skbkontur/global-object';
import { isKonturIcon } from "../../../lib/utils";
import { isKeyArrowVertical, isKeyEnter, isKeySpace, someKeys } from "../../../lib/events/keyboard/identifiers";
import * as LayoutEvents from "../../../lib/LayoutEvents";
import { keyListener } from "../../../lib/events/keyListener";
import { PopupMenu } from "../../../internal/PopupMenu";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { MenuKebabIcon } from "../../../internal/icons/16px";
import { isTestEnv } from "../../../lib/currentEnvironment";
import { ThemeFactory } from "../../../lib/theming/ThemeFactory";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { rootNode } from "../../../lib/rootNode";
import { createPropsGetter } from "../../../lib/createPropsGetter";
import { isTheme2022 } from "../../../lib/theming/ThemeHelpers";
import { getFullReactUIFlagsContext, ReactUIFeatureFlagsContext } from "../../../lib/featureFlagsContext";
import { styles } from "../Kebab.styles";
import { KebabIcon } from "../KebabIcon";
export var KebabDataTids = {
  caption: 'Kebab__caption'
};
export var Kebab = rootNode(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Kebab, _React$Component);

  function Kebab() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.getProps = createPropsGetter(Kebab.defaultProps);
    _this.state = {
      focusedByTab: false,
      anchor: null
    };
    _this.listener = {
      remove: function remove() {
        return undefined;
      }
    };

    _this.renderCaption = function (captionProps) {
      var _this$getProps = _this.getProps(),
          disabled = _this$getProps.disabled,
          size = _this$getProps.size;

      var handleCaptionKeyDown = function handleCaptionKeyDown(event) {
        if (!disabled) {
          _this.handleCaptionKeyDown(event, captionProps.openMenu);
        }
      };

      var handleCaptionClick = function handleCaptionClick() {
        if (!disabled) {
          captionProps.toggleMenu();
        }
      };

      return /*#__PURE__*/React.createElement("span", {
        role: "button",
        "data-tid": KebabDataTids.caption,
        tabIndex: disabled ? -1 : 0,
        onClick: handleCaptionClick,
        onKeyDown: handleCaptionKeyDown,
        onFocus: _this.handleFocus,
        onBlur: _this.handleBlur,
        className: cx(styles.kebab(_this.theme), size === 'small' && styles.kebabSmall(_this.theme), size === 'medium' && styles.kebabMedium(_this.theme), size === 'large' && styles.kebabLarge(_this.theme), isTheme2022(_this.theme) && styles.kebab2022(), captionProps.opened && styles.opened(_this.theme), disabled && styles.disabled(), _this.state.focusedByTab && styles.focused(_this.theme)),
        "aria-describedby": _this.props['aria-describedby']
      }, isTheme2022(_this.theme) ? _this.renderIcon2022() : _this.renderIcon());
    };

    _this.handleCaptionKeyDown = function (e, openMenu) {
      if (someKeys(isKeyEnter, isKeySpace, isKeyArrowVertical)(e)) {
        e.preventDefault();
        openMenu(true);
      }
    };

    _this.handleChangeMenuState = function (isOpened, restoreFocus) {
      _this.setState({
        focusedByTab: !isOpened && restoreFocus
      });
    };

    _this.handleFocus = function () {
      if (!_this.props.disabled) {
        // focus event fires before keyDown eventlistener
        // so we should check tabPressed in async way
        globalObject.requestAnimationFrame == null ? void 0 : globalObject.requestAnimationFrame(function () {
          if (keyListener.isTabPressed) {
            _this.setState({
              focusedByTab: true
            });
          }
        });
      }
    };

    _this.handleBlur = function () {
      _this.setState({
        focusedByTab: false
      });
    };

    return _this;
  }

  var _proto = Kebab.prototype;

  _proto.componentDidMount = function componentDidMount() {
    /** addListener'у нужен колбэк в аргумент */
    this.listener = LayoutEvents.addListener(function () {
      return undefined;
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.listener.remove();
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
        value: ThemeFactory.create({
          popupPinOffset: theme.kebabPinOffset,
          popupMargin: theme.kebabMargin,
          popupPinSize: theme.kebabPinSize,
          menuScrollContainerContentWrapperPaddingY: theme.menuLegacyPaddingY
        }, theme)
      }, _this2.renderMain());
    });
  };

  _proto.renderMain = function renderMain() {
    var _this3 = this;

    var disabled = this.props.disabled;

    var _this$getProps2 = this.getProps(),
        positions = _this$getProps2.positions,
        disableAnimations = _this$getProps2.disableAnimations,
        onOpen = _this$getProps2.onOpen,
        onClose = _this$getProps2.onClose;

    return /*#__PURE__*/React.createElement(ReactUIFeatureFlagsContext.Consumer, null, function (flags) {
      var hasPin = !getFullReactUIFlagsContext(flags).kebabHintRemovePin || !isTheme2022(_this3.theme);
      return /*#__PURE__*/React.createElement(CommonWrapper, _extends({
        rootNodeRef: _this3.setRootNode
      }, _this3.props), /*#__PURE__*/React.createElement(PopupMenu, {
        popupHasPin: hasPin,
        preventIconsOffset: _this3.props.preventIconsOffset,
        positions: positions,
        onChangeMenuState: _this3.handleChangeMenuState,
        caption: _this3.renderCaption,
        disableAnimations: disableAnimations,
        menuMaxHeight: _this3.props.menuMaxHeight,
        onOpen: onOpen,
        onClose: onClose,
        popupMenuId: _this3.props.popupMenuId,
        "aria-label": _this3.props['aria-label']
      }, !disabled && _this3.props.children));
    });
  };

  _proto.renderIcon = function renderIcon() {
    var _cx;

    var _this$getProps3 = this.getProps(),
        size = _this$getProps3.size,
        _this$getProps3$icon = _this$getProps3.icon,
        icon = _this$getProps3$icon === void 0 ? /*#__PURE__*/React.createElement(MenuKebabIcon, null) : _this$getProps3$icon;

    return /*#__PURE__*/React.createElement("div", {
      className: cx((_cx = {}, _cx[styles.icon(this.theme)] = true, _cx[styles.iconsmall(this.theme)] = size === 'small', _cx[styles.iconmedium(this.theme)] = size === 'medium', _cx[styles.iconlarge(this.theme)] = size === 'large', _cx))
    }, icon);
  };

  _proto.renderIcon2022 = function renderIcon2022() {
    var _this$getProps4 = this.getProps(),
        size = _this$getProps4.size,
        _this$getProps4$icon = _this$getProps4.icon,
        icon = _this$getProps4$icon === void 0 ? /*#__PURE__*/React.createElement(KebabIcon, null) : _this$getProps4$icon;

    if (isElement(icon) && isKonturIcon(icon)) {
      var _icon$props$size, _icon$props$color;

      var sizes = {
        small: parseInt(this.theme.kebabIconSizeSmall),
        medium: parseInt(this.theme.kebabIconSizeMedium),
        large: parseInt(this.theme.kebabIconSizeLarge)
      };
      return /*#__PURE__*/React.cloneElement(icon, {
        size: (_icon$props$size = icon.props.size) != null ? _icon$props$size : sizes[size],
        color: (_icon$props$color = icon.props.color) != null ? _icon$props$color : this.theme.kebabIconColor
      });
    }

    return icon;
  };

  return Kebab;
}(React.Component), _class2.__KONTUR_REACT_UI__ = 'Kebab', _class2.displayName = 'Kebab', _class2.propTypes = {}, _class2.defaultProps = {
  onOpen: function onOpen() {
    return undefined;
  },
  onClose: function onClose() {
    return undefined;
  },
  positions: ['bottom left', 'bottom right', 'top left', 'top right'],
  size: 'small',
  disableAnimations: isTestEnv
}, _temp)) || _class;
Kebab.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  menuMaxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Размер кебаба small 14px | large 20px
   */
  size: PropTypes.string,

  /**
   * Коллбек, вызывающийся перед закрытием кебаба
   */
  onClose: PropTypes.func,

  /**
   * Коллбек, вызывающийся перед открытием кебаба
   */
  onOpen: PropTypes.func
};